import { useEffect } from "react";

// Service schema for each core service offered. Renders a JSON-LD block
// so AI assistants and search engines can extract structured Service data.
const services = [
  {
    name: "Mobile Interior Car Detailing",
    description:
      "Full vacuum, steam clean of carpets and upholstery, leather conditioning, dashboard and trim wipe-down, glass cleaning, and odor neutralizing — performed at your home or office across DC, MD, and VA.",
    price: "179",
  },
  {
    name: "Mobile Exterior Car Detailing",
    description:
      "Foam hand wash, decontamination, hand dry, tire and trim dressing, and ceramic spray sealant. Safe for ceramic coatings, PPF, vinyl wraps, and tinted windows.",
    price: "149",
  },
  {
    name: "Mobile Full Car Detailing",
    description:
      "Combined interior and exterior premium detail, hand-finished by Metroshine's owner-run team. Same-week availability across the DMV.",
    price: "249",
  },
  {
    name: "Ceramic Sealant Application",
    description:
      "Hydrophobic ceramic spray sealant providing 3–6 months of paint protection, gloss enhancement, and easier washing.",
    price: "49",
  },
  {
    name: "Paint Correction",
    description:
      "Machine polishing using a paint depth gauge and progressive pads/compounds to safely remove swirls, light scratches, and oxidation. Priced per panel.",
    price: "65",
  },
  {
    name: "Mobile Hand Wash",
    description:
      "Touchless foam soak followed by a two-bucket hand wash and microfiber dry — the safest weekly maintenance wash for any vehicle.",
    price: "79",
  },
];

const ServicesSchema = () => {
  useEffect(() => {
    const data = services.map((s, i) => ({
      "@context": "https://schema.org",
      "@type": "Service",
      "@id": `https://themetroshine.com/services#${i}`,
      serviceType: s.name,
      name: s.name,
      description: s.description,
      areaServed: [
        { "@type": "City", name: "Vienna" },
        { "@type": "City", name: "McLean" },
        { "@type": "City", name: "Tysons" },
        { "@type": "City", name: "Arlington" },
        { "@type": "City", name: "Fairfax" },
        { "@type": "City", name: "Great Falls" },
        { "@type": "City", name: "Bethesda" },
        { "@type": "City", name: "Washington, DC" },
      ],
      provider: {
        "@type": "AutoDetailing",
        name: "Metroshine",
        url: "https://themetroshine.com",
        address: {
          "@type": "PostalAddress",
          addressLocality: "Vienna",
          addressRegion: "VA",
          postalCode: "22180",
          addressCountry: "US",
        },
      },
      offers: {
        "@type": "Offer",
        price: s.price,
        priceCurrency: "USD",
        availability: "https://schema.org/InStock",
        url: "https://themetroshine.com/book",
      },
    }));

    let script = document.getElementById("ld-json-services") as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.id = "ld-json-services";
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(data);
    return () => { script?.remove(); };
  }, []);
  return null;
};

export default ServicesSchema;
